<template>
  <tabbed-editor-header-card :md="24" :lg="18" :xl="16" :title="title" class="order-info-header">
    <div class="divTable">
      <div class="divTableBody">
        <div class="divTableRow">
          <div class="divTableCell">
            <span class="order-info-header-label">{{ $t('orderLine.customerReference') }}</span>
          </div>
          <div class="divTableCell">
            <span class="order-info-header-value">{{ customerReference }}</span>
          </div>
          <div class="divTableCell">
            <span class="order-info-header-label">{{ $t('order.source') }}</span>
          </div>
          <div class="divTableCell">
            <span class="order-info-header-value">{{ source }}</span>
          </div>
          <div class="divTableCell">
            <span class="order-info-header-label">{{ $t('orderLine.workshop') }}</span>
          </div>
          <div class="divTableCell">
            <span class="order-info-header-value">{{ workshopName }}</span>
          </div>
        </div>

        <div class="divTableRow">
          <div class="divTableCell">
            <span class="order-info-header-label">{{ $t('order.storeName') }}</span>
          </div>
          <div class="divTableCell">
            <span class="order-info-header-value">{{ storeName }}</span>
          </div>
          <div class="divTableCell">
            <span class="order-info-header-label">{{ $t('orderLine.ticketType') }}</span>
          </div>
          <div class="divTableCell">
            <span class="order-info-header-value">{{ ticketType }}</span>
          </div>
          <div class="divTableCell">
            <span class="order-info-header-label">{{ $t('orderLine.seriesNumber') }}</span>
          </div>
          <div class="divTableCell">
            <span class="order-info-header-value">{{ seriesNumber }}</span>
          </div>
        </div>
      </div>
    </div>
  </tabbed-editor-header-card>
</template>

<script>
import TabbedEditorHeaderCard from '@/components/crud/TabbedEditorHeaderCard';

export default {
  components: {
    TabbedEditorHeaderCard
  },
  props: {
    orderInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    title() {
      let title = '';
      if (this.orderInfo && this.orderInfo.ticketNumber) {
        title = this.orderInfo.ticketNumber;
      }
      return title;
    },
    storeName() {
      if (!this.orderInfo) {
        return '';
      }
      const store = this.$store.getters['store/getLoadedItemByID'](this.orderInfo.storeID);
      return store && `${store.code || ''} ${store.name} `;
    },
    customerReference() {
      return this.orderInfo.customerReference;
    },
    source() {
      return this.orderInfo.source;
    },
    workshopName() {
      return this.orderInfo.plannedWorkshopName;
    },
    seriesNumber() {
      return this.orderInfo.seriesNumber;
    },
    ticketType() {
      const option = this.$store.getters['option/loadedOptions']('orderTicketType').find(
        item => item.code === this.orderInfo.ticketType
      );
      return option && option.description;
    }
  }
};
</script>

<style lang="scss">
.order-info-header {
  .el-card {
    min-height: 60px;
    margin-top: 5px;
  }
}
</style>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
.order-info-header {
  .order-info-header-value,
  .order-info-header-label {
    margin-top: 0.8em;
    font-size: 0.9em;
  }
  .order-info-header-value {
    color: black;
  }
  .order-info-header-label {
    color: $-textDark;
    font-weight: bold;
    margin-right: 10px;
  }
  .divTable {
    display: table;
    margin-top: 5px;
  }
  .divTableRow {
    display: table-row;
  }
  .divTableCell {
    display: table-cell;
    padding: 1px 5px;
  }
  .divTableBody {
    display: table-row-group;
  }
}
</style>
